// This file contains the configuration for the web menu and online ordering API URLs.
// const env = "dev";
// export const config = env === "dev" ? devconfig : prodconfig;
// export const config = {
//   web_menu_api_url: "https://my.cpos.com/restaurant_login/api/web_menu/",
//   online_ordering_api_url:
//     "https://my.cpos.com/restaurant_login/api/online_ordering/",
//   order_history_ui_url: "https://order.orderonthego.com/orderHistory",
// };

 export const config = {
  web_menu_api_url: "https://my.cpospreprod.com/api/web_menu/",
  // online_ordering_api_url:
  //   "https://qa.orderonthego.ca/restaurant_login=>replace with preprod/api/online_ordering/",
    online_ordering_api_url:
    "https://my.cpospreprod.com/api/online_ordering/",
  order_history_ui_url: "https://order.cpospreprod.com/orderHistory",
};
